import { categoryLauncherFullWidthInit } from "@/helpers/builder-init/CategoryLauncherFullWidth"; 
import { categoryLauncherInit } from "@/helpers/builder-init/CategoryLauncher";
import { contentRandomizerInit } from "@/helpers/builder-init/ContentRandomizer";
import { customerServiceTilesInit } from "@/helpers/builder-init/CustomerServiceTiles";
import { departmentContactsInit } from "@/helpers/builder-init/DepartmentContacts";
import { featuredLinksInit } from "@/helpers/builder-init/FeaturedLinks";
import { featuredProductCarouselInit } from "@/helpers/builder-init/FeaturedProductCarousel";
import { fullWidth5050Image } from "@/helpers/builder-init/5050ImageFullWidth";
import { heroBannerInit } from "@/helpers/builder-init/HeroBanner"
import { highlightImageInit } from "@/helpers/builder-init/HighlightsImage";
import { lifeStyleImagesInit } from "@/helpers/builder-init/LifeStyleImages";
import { featuredContentInit } from "@/helpers/builder-init/FeaturedContent";
import { paragraphInit } from "@/helpers/builder-init/Paragraph";
import { productCarouselInit } from "@/helpers/builder-init/ProductCarousel";
import { productCollectionWithCardsInit } from "@/helpers/builder-init/ProductCollectionWithCards";
import { productSystemsInit } from "@/helpers/builder-init/ProductSystems";
import { rowPanelInit } from "@/helpers/builder-init/RowPanel";
import { specSheetInit } from "@/helpers/builder-init/SpecSheet";
import { textAndImageInit } from "@/helpers/builder-init/TextAndImage";
import { twoColumnImagePanelInit } from "@/helpers/builder-init/TwoColumnImagePanel";  
import { ugcInit } from "@/helpers/builder-init/UGC";

// import { categoryTilesInit } from "@/helpers/builder-init/CategoryTiles";
// import { seoCopyInit } from "@/helpers/builder-init/SeoCopy";
// import { subCategoryGridInit } from "@/helpers/builder-init/SubCategoryGrid";
// import { subCategoryLaunchers } from "@/helpers/builder-init/SubCategoryLaunchers";

export function getBuilderComponents(options={include: []}){
    const { include } = options;
    return [
        categoryLauncherFullWidthInit,
        categoryLauncherInit,
        contentRandomizerInit,
        customerServiceTilesInit,
        departmentContactsInit,
        featuredLinksInit,
        featuredProductCarouselInit,
        fullWidth5050Image,
        heroBannerInit,
        highlightImageInit,
        lifeStyleImagesInit,
        featuredContentInit,
        paragraphInit,
        productCarouselInit,
        productCollectionWithCardsInit,
        productSystemsInit,
        rowPanelInit,
        specSheetInit,
        textAndImageInit,
        twoColumnImagePanelInit,
        ugcInit,

        ...include      
    ]
}
